<div class="maincss1">
    <!-- Main -->
    <div [ngClass]="{
        'maincss2': leadDetailType === 3,
        'maincss3': leadDetailType !== 3
      }">
        <div class="feed" *ngIf="leadDetailType === 3">
            <!-- Title -->

            <!-- <div class="maintitle">All Activities</div>
            <div class="subtitle">Application wide activities are listed here as individual items, starting with the most recent.</div> -->

            <ng-container *ngIf="activities.length">
                <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                    <h4 class="fw-semibold">Activities</h4>
                    <div>
                        <div class="form-sort">
                            <i class="ti ti-sort-ascending-2"></i>
                            <mat-select class="select space-select" placeholder="Sort By Date">
                                <mat-option>Sort By Date</mat-option>
                                <mat-option>Ascending</mat-option>
                                <mat-option>Descending</mat-option>
                            </mat-select>
                        </div>
                    </div>
                </div>

                <div class="margin-top: 2rem">
                    <ol>
                        <!-- Activities -->
                        <ng-container
                            *ngFor="let activity of activities; let i = index; let first = first; let last = last; trackBy: trackByFn">
                            <!-- Date separator -->
                            <ng-container *ngIf="first || !isSameDay(activity.date, activities[i - 1].date)">

                                <div class="badge badge-soft-purple fs-14 fw-normal shadow-none mb-3">
                                    <i class="ti ti-calendar-check me-1"></i>{{getRelativeFormat(activity.date) |
                                    titlecase}}
                                </div>
                            </ng-container>
                            <!-- Activity -->
                            <ng-container>
                                <div class="card border shadow-none mb-3">
                                    <div class="card-body p-3">
                                        <div class="d-flex">
                                            <span class="avatar avatar-md flex-shrink-0 rounded me-2"
                                                [ngClass]="activity.iconBackground"
                                                [style.backgroundColor]="(activity.icon === 'phone' || getActivityIcon(activity) === 'phone') ? 'green' : ''"
                                                style="margin-right: 10px;">
                                                <mat-icon class="ti">{{activity.icon || getActivityIcon(activity)}}
                                                </mat-icon>
                                                <!-- <i class="ti" [ngClass]="activity.icon"></i> -->
                                            </span>
                                            <div>
                                                <h6 class="fw-medium mb-1">{{ activity.title || activity.subject || activity.emailSubject || activity.activityType || 'Activity' }}</h6>
                                                <p *ngIf="activity.extraContent || activity.emailBody || activity.notes" class="mb-1"
                                                    [innerHTML]="activity.extraContent || activity.emailBody || activity.notes"></p>
                                                <p class="activity-date-color">{{ activity.date }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                        </ng-container>
                    </ol>
                </div>




            </ng-container>

            <div *ngIf="isLoading" class="loading-spinner">
                Loading more activities...
            </div>

            <div #noActivity *ngIf="!isLoading && !hasMore && activities.length" class="no-more-activities">
                No more activities to load
            </div>

            <div *ngIf="!isLoading && !activities?.length" class="no-record-found">
                <mat-icon class="no-record-icon">info_outline</mat-icon>
                <span>No Record Found</span>
            </div>
        </div>
        <div class="feed-container" *ngIf="leadDetailType != 3 ">
            <!-- Title -->

            <!-- <div class="maintitle">All Activities</div>
            <div class="subtitle">Application wide activities are listed here as individual items, starting with the most recent.</div> -->
            <div class="feed" #activityFeed>
                <div #scrollContainer  class="scroll-container" infiniteScroll [infiniteScrollDistance]="0.4"
                    [infiniteScrollThrottle]="50" [scrollWindow]="false" [infiniteScrollContainer]="scrollContainer"
                    (scrolled)="onScroll()">

                    <ng-container *ngIf="leadActivityList.length">

                        <div class="margin-top: 2rem">
                            <ol>
                                <!-- Activities -->
                                <div
                                    *ngFor="let activity of leadActivityList; let i = index; let first = first; let last = last; trackBy: trackByFn">

                                    <calsoft-child-activitiy [last]="last" [activity]="activity"
                                        [date]="activity.createdDate"
                                        [beforeDate]="leadActivityList[i - 1]?.createdDate"
                                        [afterDate]="leadActivityList[i + 1]?.createdDate" [first]="first">
                                    </calsoft-child-activitiy>



                                </div>






                            </ol>
                            <div fxLayout="row" fxLayoutAlign="center center" *ngIf="spinner">
                                <mat-spinner [diameter]="20"></mat-spinner>
                            </div>

                        </div>




                    </ng-container>

                    <div *ngIf="isLoading" class="loading-indicator">
                        Loading Activities
                    </div>

                    <div *ngIf="!hasMore && !isLoading && activities.length > 0" class="no-more-text">
                        No more activities to show
                    </div>

                    <div *ngIf="!isLoading && !spinner && !leadActivityList?.length" class="no-record-found">
                        <mat-icon class="no-record-icon">info_outline</mat-icon>
                        <span>No Record Found</span>
                    </div>
                </div>

            </div>
        </div>
    </div>